import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { selectSettings } from "../store/selector";

export const parseValues = (setting) => {
  if (!setting) {
    return "";
  }
  const valueParser = {
    bool: (value) => value === "true",
    string: (value) => value,
    date: (date) => moment(date),
    json: (value) => JSON.parse(value),
    number: (float) => parseFloat(float)
  };
  return valueParser[setting.type](setting.value);
};

const useGetSetting = (settingList) => {
  const allSettings = useSelector(selectSettings);
  // Guard the settings slice: a consumer can render before settings are in the store (e.g. the
  // ee_review render-contract mounts config hooks against a minimal state), and reading a key off an
  // undefined slice threw. parseValues already treats a missing setting as empty, so `?.` just extends
  // that to a missing slice. No effect in the app, where the settings reducer is always initialized.
  return settingList.map((key) => parseValues(allSettings?.[key]));
};

export { useGetSetting };
